import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { PanelsTopLeft } from 'lucide-react';
import { FleetPortalClaimViewSettings } from './FleetPortalClaimViewSettings';

export const Route = createFileRoute('/console/$orgId/configuration/fleet/portal-claim-page')({
    staticData: {
        // The fleet module is the per-tenant switch for this page (CUR-1069):
        // an organisation that does not run fleet never sees it.
        metadata: {
            title: 'Portal claim page',
        },
        ui: {
            icon: PanelsTopLeft,
            title: 'Portal claim page',
            subtitle:
                'Which sections of a claim your fleet managers see in the portal. A section switched off is not sent to the portal at all, and the change takes effect on the next page load.',
            menuDescription: 'Choose which claim sections fleet managers see in the portal',
        },
        modules: ['fleet'],
        permissions: ['settings:update'],
    },
    component: ConfigurationFleetPortalClaimView,
});

function ConfigurationFleetPortalClaimView() {
    return (
        <PageController route={Route}>
            <FleetPortalClaimViewSettings />
        </PageController>
    );
}
